var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-field',[_c('b-input',{attrs:{"type":"textarea","minlength":_vm.$props.minLength,"maxlength":_vm.$props.maxLength,"placeholder":_vm.$props.placeholder,"has-counter":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }